const KeenSlider = window.KeenSlider

class ProductRecommendationCarousel extends HTMLElement {
  constructor () {
    super()

    this.carousel = this.querySelector(
      '[data-product-recommendation-carousel-el="slider"]',
    )
    this.items = this.querySelectorAll(
      '[data-product-recommendation-carousel-el="slide"]',
    )

    this.prevEl = this.querySelector(
      '[data-product-recommendation-carousel-el="prev"]',
    )
    this.nextEl = this.querySelector(
      '[data-product-recommendation-carousel-el="next"]',
    )

    if (!this.carousel || !this.items.length) return
    this.slider = this.initialiseCarousel()
  }

  initialiseCarousel () {
    return new KeenSlider(this.carousel, {
      loop: false,
      mode: 'snap',
      slides: {
        perView: 2,
        spacing: 5,
      },
      breakpoints: {
        '(min-width: 768px)': {
          slides: {
            perView: 3,
          },
        },
        '(min-width: 900px)': {
          slides: {
            perView: 4,
          },
        },
      },
    },
    [
      window.BAO.Carousel.plugins.useInitialised(),
      window.BAO.Carousel.plugins.useArrows({
        next: this.nextEl,
        previous: this.prevEl,
      }),
    ],
    )
  }
}

customElements.define('product-recommendation-carousel', ProductRecommendationCarousel)
